export const formatPrice = (price, dropZeros) => {
  if (price == null || price <= 0) return '';
  if (price < 1 && price !== 0) return `${(price * 100).toFixed()}¢`;
  if (dropZeros && price % 1 === 0) return `$${parseFloat(price)}`;
  return `$${parseFloat(price).toFixed(2)}`;
};

export const formattedReward = ({
  rewardPercent,
  rewardAmountPerOrder,
  rewardFixedPrice
}, dropZeros) => {

  if (rewardPercent) return `${rewardPercent}%`;
  // No savings messaging for rewardFixedPrice scenarios
  if (rewardFixedPrice) return '';
  return formatPrice(rewardAmountPerOrder, dropZeros);
};

export const formattedFixedPrice = ({ fixedPriceTotal, minPurchaseQuantity }) => {
  const formattedFixedPriceTotal = formatPrice(fixedPriceTotal, true);
  return `${minPurchaseQuantity} for ${formattedFixedPriceTotal}`;
};

const iOSPlatforms = [
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod'
];

export const isAppleTouch = () => (
  navigator?.platform && navigator?.userAgent
  && (iOSPlatforms.includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document))
);

// [numTiers - 1][tierNumber]
export const tierSuccessColors = [
  ['#00873C'], // $success
  ['#7CC09A', '#00873C'],
  ['#7CC09A', '#3FA36C', '#00873C'],
  ['#BBDDCA', '#7CC09A', '#3FA36C', '#00873C'],
];

export const brandColor = '#F96302';

export const progressBarInitialColor = '#CCC'; // $light

export const getProgressBarSize = ({ rewardTier, currentPromoTier, progressMade }) => {
  let value = '0%';
  if (rewardTier.tier === currentPromoTier) value = `${progressMade}%`;
  else if (rewardTier.tier < currentPromoTier) value = '100%';
  return value;
};

export const getProgressBarColor = ({ rewardTier, rewardTiers, currentPromoTier, isPromoAchieved }) => {
  let color = brandColor;
  if (rewardTier.tier < currentPromoTier || isPromoAchieved) {
    color = tierSuccessColors[rewardTiers.length - 1][rewardTier.tier];
  }
  return color;
};
